module.exports = __webpack_public_path__ + "static/img/20221219_01.1eb5e40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20221219_01.png
// module id = RJbA
// module chunks = 0